import { Controller } from 'stimulus';
import { smoothScroll, detectIE } from 'lib/helpers';
import frameDebounce from 'lib/frame-debounce';

export default class SearchSidebarController extends Controller {
  static targets = ['scrollNotice', 'stickyInner', 'filterTooltip'];

  connect() {
    if (!detectIE()) window.addEventListener('wheel', this.debouncedScrollCheck);
  }

  disconnect() {
    window.removeEventListener('wheel', this.debouncedScrollCheck);
  }

  lastScrollPos = 0;

  syncScrollWithResults = () => {
    const top = parseInt((window.pageYOffset || document.scrollTop) - (document.clientTop || 0), 10) || 0;

    const delta = top - this.lastScrollPos;
    this.lastScrollPos = top;

    this.stickyInnerTarget.scrollTop += Math.ceil(delta);
    this.updateScrollNoticeVisibilty(this.stickyInnerTarget.scrollTop);
  }

  debouncedScrollCheck = frameDebounce(this.syncScrollWithResults);

  scrollNoticeVisible = false;

  updateScrollNoticeVisibilty(scrollTop) {
    if (scrollTop > 200 && !this.scrollNoticeVisible) {
      this.scrollNoticeTarget.dataset.visible = true;
      this.scrollNoticeVisible = true;
    } else if (scrollTop < 150 && this.scrollNoticeVisible) {
      this.scrollNoticeTarget.dataset.visible = false;
      this.scrollNoticeVisible = false;
    }
  }

  backToTop() {
    this.scrollNoticeTarget.dataset.visible = false;
    this.scrollNoticeVisible = false;
    smoothScroll(0, this.stickyInnerTarget);
  }
}
